import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllCourses } from '../services/courseService';
import './Hero.css';

function Hero() {
  const [coursesCount, setCoursesCount] = useState(10);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await getAllCourses({ isActive: true });
        if (response?.success && Array.isArray(response.data) && response.data.length > 0) {
          setCoursesCount(response.data.length);
        }
      } catch (err) {
        console.error('Error fetching course count:', err);
      }
    };
    fetchStats();
  }, []);

  return (
    <>
      <section class="hero-section" id="hero">
        <div className="hero-grid-pattern"></div>
        <div className="hero-ambient-glow"></div>
        <div className="container">
          <div className="hero-wrapper">
            <div className="hero-pills-bar" aria-label="Learning Philosophy">
              <span className="hero-text-item">LEARN</span>
              <span className="hero-text-sep">&middot;</span>
              <span className="hero-text-item">CODE</span>
              <span className="hero-text-sep">&middot;</span>
              <span className="hero-text-item">BUILD</span>
            </div>

            <h1 className="hero-heading">
              Done With Theory? <span className="gradient-text">Let’s Build for Real</span>
            </h1>

            <p className="hero-subtitle">
              Build practical software engineering skills through hands-on projects, structured learning, and real-world development with modern technologies.
            </p>

            <div className="hero-cta-group">
              <Link to="/courses" className="btn btn-primary btn-lg">
                <span>Explore Cohorts</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>

            <div className="hero-tech-strip">
              <span className="tech-strip-label">Core Tech:</span>
              <span className="hero-tech-pill">Rust</span>
              <span className="hero-tech-pill">FastAPI</span>
              <span className="hero-tech-pill">PostgreSQL</span>
              <span className="hero-tech-pill">Apache Kafka</span>
              <span className="hero-tech-pill">Docker</span>
              <span className="hero-tech-pill">Kubernetes</span>
              <span className="hero-tech-pill">Linux Systems</span>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="stats-bar" aria-label="Key Platform Metrics">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">{coursesCount}+</span>
              <span className="stat-label">Active Cohorts</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">30 Max</span>
              <span className="stat-label">Students per Cohort</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">96%</span>
              <span className="stat-label">Architecture Defense Pass Rate</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Pull Request Review Coverage</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;
